export default "__VITE_ASSET__DhtzCzno__"